import React from 'react'
import SearchBar from './SearchBar';
import { useResponsiveUtil } from '../util/responsive-util';
import { SideMenu } from './SideMenu';
import { Tariffario } from './Tariffario';

export const MainContent = () => {
    const { isTabletDevice } = useResponsiveUtil();

    return (
        <div className="MainContent">
            <SearchBar />
            {!isTabletDevice && <SideMenu />}
            <Tariffario />
        </div>
    )
}
